import Delete from './Delete/Delete';

export const Resource = {
  Delete: Delete,
};
